export default __webpack_public_path__ + "static/media/BLAZE-Logo-fullColor-LT_1.0534cfcb.svg";